/*
 This module provide the client for accessing Digistore24 website to retrieve product catalog and order information.
*/

import axios from 'axios'

// see: https://rollout.com/integration-guides/digistore24/sdk/step-by-step-guide-to-building-a-digistore24-api-integration-in-js
// digistore24 API: https://www.digistore24.com/api/docs/index.html

// digistore24proxy configuration
const LOCAL_HOST = 'http://ccu3-webui.fritz.box/addons/red';
const API_ROOT = '/digistore24Proxy';

// construct the API endpoint URL
const getEndpoint = () => {
    // assume APIs are served from the same server as Webapp
    // must be used in production to prevent CORS problems
    var loc = window.location;
    var baseHoststring = loc.protocol + "//" + loc.host;
    var hoststring = baseHoststring;
    // you can overwrite it here
    //hoststring = 'http://cloudia.fritz.box';
    //hoststring = "https://my.happinessandwork.de";
    if (loc.host.indexOf('localhost') !== -1) {
        hoststring = LOCAL_HOST;
    }     
    // happiness API configuration
    var api =  hoststring + API_ROOT;
    console.log('Constructed API endpoint:', api); // eslint-disable-line no-console
    return api;
}

const api = axios.create({
  baseURL: getEndpoint(),
  //baseURL: 'https://www.digistore24.com/api/call',
  //headers: { 'X-DS24-API-KEY': '<key>' }
});

// client module for email notification
export default class Digistore24ClientService {

  async getProducts() {
    try {
      const response = await api.get('/listProducts?sort_by=name');
      //console.log(response.data);
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Unknown error while fetching products';
      throw new Error(errorMessage);
    }
  }

  async getProduct(productId) {
    try {
      const response = await api.get(`/getProduct?product_id=${productId}`);
      return response.data;
    } catch (error) {
      const errorMessage = error.response?.data?.message || error.message || 'Unknown error while fetching product';
      throw new Error(errorMessage);
    }
  }

}

  /* service usage
    const digistore24ClientService = new Digistore24ClientService();
    try {
      const res = await digistore24ClientService.getProducts();
      this.productsLoadError = '';
      if (res && Array.isArray(res.data.products)) {
        this.products = res.data.products;
      } else {
        this.products = [];
        this.productsLoadError = 'Produktdaten konnten nicht verarbeitet werden.';
      }
    } catch (error) {
      this.products = [];
      this.productsLoadError = `Produkte konnten nicht geladen werden: ${error.message || 'Unbekannter Fehler'}`;
    }
  */

